var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoVolumeOn = function SvgIcoVolumeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M10.293 20.706c.63.63 1.707.183 1.707-.707V4c0-.89-1.077-1.337-1.707-.707l-5.74 5.74a3 3 0 0 0 0 5.932zm9.484-2.42A9.96 9.96 0 0 0 22 12a9.96 9.96 0 0 0-2.222-6.284 1 1 0 0 0-1.554 1.258A7.96 7.96 0 0 1 20 12a7.96 7.96 0 0 1-1.777 5.027 1 1 0 1 0 1.554 1.258M18 12c0 1.234-.45 2.4-1.25 3.307a1 1 0 0 1-1.5-1.323c.48-.545.75-1.242.75-1.984 0-.74-.268-1.437-.748-1.982a1 1 0 1 1 1.5-1.322A4.98 4.98 0 0 1 18 12",
    clipRule: "evenodd"
  })));
};
export default SvgIcoVolumeOn;